<template>
  <div class="back-anim">
    <div class="col-md-12" style="padding-top:100px;">
      <div class="card card-container">
        <img id="profile-img" src="../assets/logo.png" class="profile-img-card" />
        <span style="color:black"> {{ version }}</span>
        <Form @submit="handleLogin" :validation-schema="schema">
          <div class="form-group">
            <label for="username">Username</label>
            <Field name="username" v-model="email" type="text" class="form-control" />
            <ErrorMessage name="username" class="error-feedback" />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <Field name="password" type="password" class="form-control" />
            <ErrorMessage name="password" class="error-feedback" />
          </div>

          <div class="form-group pt-4">
            <button class="btn btn-primary btn-block pt" :disabled="loading">
              <span v-show="loading" class="spinner-border spinner-border-sm"></span>
              <span>Login</span>
            </button>
          </div>

          <div class="form-group">
            <div v-if="message" class="alert alert-danger " role="alert">
              {{ message }}
            </div>
          </div>

        </Form>
        <div class="message">
          <a href="#" v-on:click="forgetPassword">Forgot Password?</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import AuthService from "../services/auth.service";

export default {
  name: "Login",
  components: {
    Form,
    Field,
    ErrorMessage,
    AuthService
  },
  data() {
    const schema = yup.object().shape({
      username: yup.string().required("Username is required!"),
      password: yup.string().required("Password is required!"),
    });

    return {
      email: '',
      loading: false,
      message: "",
      schema,
    };
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
    loggedIn() {
      return this.$store.state.loggedIn;
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push("/monitordashboard");
    }
  },
  methods: {
    
    forgetPassword: function () {
      AuthService.forgotPassword(
        this.email,
      ).then(
        (response) => {
          alert("Password reset request successful. We will send you an email with the instructions you need to follow in order to access your account again. Please check your e-mail for the next few minutes, including Spam and Spam folders.")
        },
        (error) => {
          alert(error)
        }
      );
    },
    handleLogin(user) {
      this.loading = true;

      this.$store.dispatch("login", user).then(
        () => {
          ;
        },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
  },
};
</script>

<style scoped></style>
